import { render, staticRenderFns } from "./PlayerUnbanPreview.vue?vue&type=template&id=d931bf7a&scoped=true&"
import script from "./PlayerUnbanPreview.vue?vue&type=script&lang=js&"
export * from "./PlayerUnbanPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlayerUnbanPreview.vue?vue&type=style&index=0&id=d931bf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d931bf7a",
  null
  
)

export default component.exports